import OurImage from "assets/images/Diversity.svg";
import ScrollReveal from "components/common/ScrollReveal";
import SectionHeading from "components/common/SectionHeading";

const HIGHLIGHTS = [
    "Certified IT professionals across cloud, security, and data",
    "Proven track record with enterprise and public sector clients",
    "End-to-end solutions from strategy to managed operations",
];

const WhoWeAre = () => {
    return (
        <section className="gradient-mesh overflow-hidden">
            <div className="container">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    <ScrollReveal variant="left">
                        <div className="relative max-w-md mx-auto lg:max-w-none">
                            <img
                                src={OurImage}
                                alt="Who we are?"
                                className="w-full"
                            />
                        </div>
                    </ScrollReveal>

                    <ScrollReveal variant="right" delay={150}>
                        <div className="text-center lg:text-left">
                            <SectionHeading
                                eyebrow="About Us"
                                title="Who we are"
                                description="With over 20 years of experience in IT consulting, data compliance, and governance, we are one of the fastest-growing companies in Asia."
                                align="left"
                                className="mb-8 !mx-0"
                            />
                            <div className="inline-flex items-baseline gap-2 mb-6">
                                <span className="text-5xl md:text-6xl font-bold text-primary">
                                    +20
                                </span>
                                <span className="text-xl md:text-2xl font-semibold text-secondary">
                                    Years Experience
                                </span>
                            </div>
                            <p className="text-secondary/80 leading-relaxed mb-8">
                                Our mission is to support businesses and
                                individuals with our expertise and excellence.
                                We partner with organizations to navigate
                                complex digital landscapes and deliver
                                measurable outcomes.
                            </p>
                            <ul className="space-y-3 text-left">
                                {HIGHLIGHTS.map((item) => (
                                    <li
                                        key={item}
                                        className="flex items-start gap-3 text-sm md:text-base text-secondary/80"
                                    >
                                        <span className="mt-1.5 w-2 h-2 rounded-full bg-primary shrink-0" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </ScrollReveal>
                </div>
            </div>
        </section>
    );
};

export default WhoWeAre;
